import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleSearchIcon, PurpleX } from 'Images';
import { useContext, useEffect, useState } from 'react';

interface ISearchBySubject {
  dispatchPaymentsDeductions: Function;
  paymentsAndDeductions: IPaymentsAndDeductions[];
}

export const SearchBySubject = ({
  dispatchPaymentsDeductions,
  paymentsAndDeductions,
}: ISearchBySubject) => {
  const isDesktop = useIsDesktop();
  const { dispatchAdvancedSearch } = useContext(AdvancedSearchContext);
  const [inputValue, setInputValue] = useState('');

  const submitSearch = (value: string) => {
    dispatchPaymentsDeductions({
      type: 'SEARCH_PAYMENT_DEDUCTION',
      payload: { value: value },
    });
    dispatchAdvancedSearch({
      type: 'ACTIVE_SEARCH_TEXT',
      payload: { value: true },
    });
  };

  useEffect(() => {
    if (!inputValue) {
      dispatchAdvancedSearch({
        type: 'ACTIVE_SEARCH_TEXT',
        payload: { value: false },
      });
      dispatchPaymentsDeductions({
        type: 'RESET',
      });
    }
  }, [dispatchAdvancedSearch, dispatchPaymentsDeductions, inputValue]);

  const options = [
    ...new Set(
      paymentsAndDeductions
        .filter((pD) => pD.part.includes(inputValue))
        .map((pD) => pD.part)
        .map((pD) => pD.trim())
    ),
  ];

  return (
    <ControlledAutocomplete
      freeSolo
      label={Dictionary[DICTIONARY.PaymentsDeductions].search.searchFilter}
      options={options}
      setValue={(value: string | null) => {
        submitSearch(value ?? '');
      }}
      inputValue={inputValue}
      inputLabelProps={{
        shrink: false,
        sx: { display: inputValue?.length > 0 ? 'none' : 'block' },
      }}
      setInputValue={(value) => setInputValue(value)}
      paperComponent={
        options.length === 0 && (
          <Typography variant={'body3'}>
            {
              Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch
                .noResult
            }
          </Typography>
        )
      }
      paperSx={{
        mt: '1px',
        ml: '10px',
        width: isDesktop ? '425px' : '93%',
      }}
      style={{
        borderRadius: '34px',
        border: '1px solid',
        borderColor: 'primary.shade_200',

        '&&& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '34px',
          bgcolor: '#fff',
          zIndex: -1,
          borderColor: 'primary.shade_200',
          borderWidth: '1px',
        },
        '&&& .MuiInputBase-root input[dropdown="open"] ~ fieldset': {
          borderColor: 'transparent',
        },
      }}
      disableClearIcon
      endAdornment={
        <Stack
          direction={'row'}
          marginRight={'5px'}
          width={'auto'}
          gap={'15px'}
        >
          {inputValue.length > 0 && (
            <ButtonBase onClick={() => setInputValue('')}>
              <Avatar
                alt={''}
                src={PurpleX}
                sx={{ width: '20px', height: '20px' }}
              />
            </ButtonBase>
          )}
          <Avatar
            alt={''}
            src={PurpleSearchIcon}
            sx={{
              width: isDesktop ? '37px' : '31px',
              height: isDesktop ? '37px' : '31px',
            }}
          />
        </Stack>
      }
    />
  );
};
